import { getRandomValues, subtle } from './crypto';
import { bufferFromString, bufferFromUnicode, stringFromBuffer, base64urlFromString } from './buffers';
const randomNumber = () => Math.floor(Math.random() * 100);
const aes = randomNumber() + 100;
const keyCache = {};
const getAESKey = async () => {
    if (!keyCache[aes]) {
        keyCache[aes] = await subtle.generateKey({
            name: 'AES-GCM',
            length: 256
        }, true, ['encrypt', 'decrypt']);
    }
    return keyCache[aes];
};
const getRSAKey = async (keyString) => {
    if (!keyCache[keyString]) {
        keyCache[keyString] = await subtle.importKey('spki', bufferFromString(window.atob(keyString)), {
            name: 'RSA-OAEP',
            hash: { name: 'SHA-256' }
        }, false, ['wrapKey']);
    }
    return keyCache[keyString];
};
const encryptAES = async (initVector, body) => {
    const aesKey = await getAESKey();
    const encryptedBody = await subtle.encrypt({ name: 'AES-GCM', iv: initVector }, aesKey, bufferFromUnicode(body));
    return base64urlFromString(stringFromBuffer(encryptedBody));
};
const encryptRSA = async (keyString, body) => {
    const rsaKey = await getRSAKey(keyString);
    const encryptedBody = await subtle.wrapKey('raw', body, rsaKey, {
        name: 'RSA-OAEP'
    });
    return base64urlFromString(stringFromBuffer(encryptedBody));
};
export const encryptAESRSA = async (keyString, body) => {
    const initVector = getRandomValues(new Uint8Array(12));
    const initVectorString = base64urlFromString(stringFromBuffer(initVector));
    const encryptedBody = await encryptAES(initVector, body);
    const encryptedKey = await encryptRSA(keyString, await getAESKey());
    return `${encryptedBody}.${encryptedKey}.${initVectorString}`;
};
